// extracted by mini-css-extract-plugin
export var menuIcon = "_r6-0";
export var menuIconInline = "_r6-1";